import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import "./contact.scss";

export default function ContactSection() {
  return (
    <section  id="contacts" className="contact-section">
      <div className="container">
        <motion.h2
          className="title"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Свяжитесь с нами
        </motion.h2>

        <div className="content">
          <div className="cards">
  <ContactCard
    href="tel:+998933938000"
    icon={<FaPhoneAlt />}
    title="Телефон"
    text="+998 93 393-80-00"
  />
  <ContactCard
    href="mailto:info@nasokah.uz"
    icon={<FaEnvelope />}
    title="Электронная почта"
    text="info@nasokah.uz"
  />
  <ContactCard
    href="https://maps.google.com/?q=Ташкент, Узбекистан"
    icon={<FaMapMarkerAlt />}
    title="Адрес"
    text="Ташкент, Узбекистан"
  />
</div>


          <div className="cards">
            <ContactCard
              href="https://www.instagram.com/na_sokah_uz?igsh=NWE1aG4wMHl4MW1l"
              icon={<FaInstagram />}
              title="Instagram"
              text="Подпишитесь и следите за новостями"
              className="instagram"
            />
            <ContactCard
              href="https://t.me/nasokahuz"
              icon={<FaTelegramPlane />}
              title="Telegram"
              text="Подпишитесь и следите за новостями"
              className="telegram"
            />
            <ContactCard
              href="https://wa.me/998500120230"
              icon={<FaWhatsapp />}
              title="WhatsApp"
              text="Подпишитесь и следите за новостями"
              className="whatsapp"
            />
          </div>
        </div>

        <motion.div
  className="actions"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ delay: 0.6, duration: 0.6 }}
>
  <a
    href="https://wa.me/998933938000?text=Здравствуйте! Хочу позвонить 📞"
    target="_blank"
    rel="noopener noreferrer"
    className="btn call"
  >
    <FaPhoneAlt /> Позвонить сейчас
  </a>
  <a
    href="https://wa.me/998933938000?text=Здравствуйте! Пишу вам в WhatsApp 💬"
    target="_blank"
    rel="noopener noreferrer"
    className="btn whatsapp"
  >
    <FaWhatsapp /> Написать в WhatsApp
  </a>
</motion.div>
      </div>
    </section>
  );
}

function ContactCard({
  icon,
  title,
  text,
  className,
  href,
}: {
  icon: React.ReactNode;
  title: string;
  text: string;
  className?: string;
  href?: string;
}) {
  const cardContent = (
    <motion.div
      className={`contact-card ${className || ""}`}
      whileHover={{ scale: 1.05, rotate: 1 }}
      whileTap={{ scale: 0.97 }}
    >
      <div className="icon">{icon}</div>
      <div className="info">
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </motion.div>
  );

  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" className="card-link">
      {cardContent}
    </a>
  ) : (
    cardContent
  );
} 